import React from "react";
import {
  EnvelopeSimple,
  Phone,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { whatsappUrl } from "@/lib/contactChannels";
import { buildMailComposePath } from "@/lib/mailCompose";


function personName(person = {}) {
  return [person.firstName, person.lastName].filter(Boolean).join(" ")
    || person.email
    || "Non renseigné";
}


export default function InstallationContactActions({ contact = {} }) {
  const navigate = useNavigate();
  const phone = contact.phone || contact.mobile || contact.phoneNumber || "";
  const email = contact.email || "";
  const message = "Bonjour, je vous contacte concernant la planification de votre livraison et installation.";

  const openEmailComposer = () => {
    if (!email) return;

    navigate(
      buildMailComposePath({
        to: email,
      })
    );
  };

  return (
    <section className="lirah-card p-5" data-testid="installation-contact-actions">
      <div className="label-eyebrow">Contact client</div>
      <h2 className="mt-1 font-heading text-lg font-black text-[var(--do-text)]">
        {personName(contact)}
      </h2>
      {contact.company && (
        <p className="mt-1 text-sm text-[var(--do-muted)]">{contact.company}</p>
      )}

      <div className="mt-4 grid gap-2 sm:grid-cols-3 xl:grid-cols-1">
        <Button asChild variant="outline" disabled={!phone}>
          <a href={phone ? `tel:${phone}` : undefined}>
            <Phone size={17} /> Téléphoner
          </a>
        </Button>
        <Button asChild variant="outline" disabled={!phone}>
          <a
            href={phone ? whatsappUrl(phone, message) : undefined}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappLogo size={17} /> WhatsApp
          </a>
        </Button>
        <Button
          type="button"
          variant="outline"
          disabled={!email}
          onClick={openEmailComposer}
          data-testid="installation-send-email"
        >
          <EnvelopeSimple size={17} /> E-mail
        </Button>
      </div>
    </section>
  );
}
